import { gql } from "gql";
import { StateCode } from "src/utils/usStates";
import { ValidateAddressResponse, ValidationAddress } from "gql/graphql";
import { apolloClientLoggedOutToken } from "src/api/apolloClient";

// Re-export types for consumers
export type { ValidateAddressResponse, ValidationAddress };

export type UsStreetAddress = {
  address1: string;
  address2: string;
  city: string;
  state: StateCode;
  postalCode: string;
  country: string;
};

const VALIDATE_ADDRESS_QUERY = gql(`
  query ValidateAddress($address: ValidationAddressInput!, $validationService: ValidationService) {
    validateAddress(address: $address, validationService: $validationService) {
      address {
        addressLine1
        addressLine2
        city
        zoneCode
        postalCode
        countryCode
      }
      status
      errorReasons {
        reason
      }
      validationService
    }
  }
`);

export async function postValidateAddress(
  address: UsStreetAddress
): Promise<ValidateAddressResponse> {
  const result = await apolloClientLoggedOutToken.query({
    query: VALIDATE_ADDRESS_QUERY,
    variables: {
      address: {
        addressLine1: address.address1,
        addressLine2: address.address2,
        city: address.city,
        zoneCode: address.state,
        postalCode: address.postalCode,
        countryCode: address.country,
      },
    },
  });

  return result.data.validateAddress;
}
